module.exports = __webpack_public_path__ + "img/蓝色.c4e346bb.jpg";